import { FETCH_SEARCH_CONTENT, FETCH_SEARCH_USERS, LOAD_SEARCH_CONTENT, LOAD_SEARCH_USERS } from '../Actions/Search'

const initialState = {
  contents: [],
  users: []
}

/**
  * SearchReducer
  * @desc Content State handler for content data
  * @param {Object} state
  * @param {action} action
  * @return {Object} updated search state
*/
export default function SearchReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }
  switch (action.type) {
    case FETCH_SEARCH_CONTENT:
      return Object.assign({}, state, { contents: [] })
      // return Object.assign({}, state, { content: action.data.getSearchContentAnalytics.content, contentLength: action.data.getSearchContentAnalytics.count })
    case LOAD_SEARCH_CONTENT:
      return Object.assign({}, state, { contents: action.data.getSearchItemsAnalytics.searchItemsResult, searchType: 'CONTENT' })
    case FETCH_SEARCH_USERS:
      return Object.assign({}, state, { users: [] })
      // return Object.assign({}, state, { users: action.data.searchUsersAnalytics.users, usersLength: action.data.searchUsersAnalytics.count })
    case LOAD_SEARCH_USERS:
      return Object.assign({}, state, { users: action.data.getSearchItemsAnalytics.searchItemsResult, searchType: 'USER' })
    default:
      return state
  }
}
